import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ScenarioChart from 'Components/ComponentLibrary/Organisms/ScenarioChart';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useFilterContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/FilterContext';
import {
  useScenarioLoadingContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ScenarioLoadingIndicator/ScenarioLoadingContext';
import { useViewportHeight } from 'Hooks/useDimensions';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1, 3, 2),
  },
});

const TopPart = ({ classes, className }) => {
  const { pageContentResource } = usePageContentContext();
  const {
    chartTimeframe,
    setAllocationsTimeframe,
    setChartTimeframe,
  } = useFilterContext();
  const { setFacetPlanChartDataLoadingSucceeded, setFacetPlanChartDataLoadingFailed } = useScenarioLoadingContext();
  const onLoadSucceeded = () => {
    setFacetPlanChartDataLoadingSucceeded();
  };
  const onLoadFailed = () => {
    setFacetPlanChartDataLoadingFailed();
  };
  const viewportHeight = useViewportHeight();
  const chartHeight = Math.min(380, Math.round(viewportHeight * 0.25));

  return (
    <Box className={classNames(className, classes.root)}>
      <ScenarioChart
        broadcastTimeframe={setAllocationsTimeframe}
        chartDataTimeframe={chartTimeframe}
        hasNoTitle
        isCollapsible
        isInflationAdjustable
        isMultiChart
        resource={pageContentResource}
        setChartDataTimeframe={setChartTimeframe}
        onLoadSucceeded={onLoadSucceeded}
        onLoadFailed={onLoadFailed}
        height={chartHeight}
      />
    </Box>
  );
};

TopPart.defaultProps = {
  className: '',
};

TopPart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TopPart);
